const features = [
  {
    icon: 'ri-speed-up-line',
    title: '即点即播',
    desc: '采用全球CDN加速节点，页面加载毫秒级响应，视频无需缓冲等待，打开就能看，告别卡顿烦恼。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20high%20speed%20data%20stream%20with%20warm%20amber%20and%20red%20light%20trails%20on%20dark%20background%2C%20technology%20minimal%20style%2C%20speed%20lines%20composition%2C%20cinematic%20mood&width=640&height=420&seq=feature-speed&orientation=landscape'
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无扰',
    desc: '全站无弹窗广告、无强制跳转、无恶意插件，纯净观影环境让你专注享受每一部数字颜色系列作品。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20minimalist%20shield%20concept%20with%20soft%20glowing%20amber%20and%20crimson%20accents%2C%20clean%20atmosphere%2C%20luxury%20protection%20aesthetic%2C%20abstract%20digital%20security%20mood&width=640&height=420&seq=feature-safe&orientation=landscape'
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端适配',
    desc: 'PC、平板、手机全终端自适应布局，横竖屏自由切换，地铁通勤还是沙发躺看，随时随地畅享高清内容。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20multi%20device%20display%20concept%20with%20warm%20amber%20glow%20on%20dark%20surface%2C%20geometric%20minimal%20composition%2C%20responsive%20design%20vibe%2C%20luxury%20tech%20aesthetic&width=640&height=420&seq=feature-device&orientation=landscape'
  },
  {
    icon: 'ri-archive-line',
    title: '海量片库',
    desc: '每日精选更新，覆盖红桃、蓝桃、黑桃、91、97、久久等全系列数字颜色频道，经典与最新一站打尽。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20library%20archive%20concept%20with%20crimson%20and%20amber%20tones%20on%20dark%20background%2C%20floating%20geometric%20shapes%2C%20organized%20minimal%20composition%2C%20luxury%20cinematic%20mood&width=640&height=420&seq=feature-library&orientation=landscape'
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="relative py-14 md:py-20 bg-background-950">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm text-primary-400 font-medium tracking-wider uppercase mb-2">Why Us</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-50 tracking-wide">平台特色</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">妖精视频为数字颜色系列观众打造的专属观影体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group bg-background-800/40 hover:bg-background-800/70 rounded-lg overflow-hidden border border-background-700/30 hover:border-primary-500/20 transition-all duration-300"
            >
              <div className="relative h-44 md:h-48 bg-background-700/40 overflow-hidden">
                <img
                  src={feat.img}
                  alt={feat.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.display = 'none';
                    }
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-800/80 to-transparent"></div>
                <div className="absolute bottom-3 left-3 w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/20 backdrop-blur-sm text-primary-400 border border-primary-500/20">
                  <i className={`${feat.icon} text-lg`}></i>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading text-foreground-100 mb-2 tracking-wide">{feat.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}